const DOMAIN = "https://api.stg.logdms.io";
const STORAGE_DOMAIN = "https://storage.stg.logdms.io/";

module.exports = { DOMAIN, STORAGE_DOMAIN };
